import React from 'react';
export function UrgencySection() {
  return <section className="w-full bg-pink-soft border-t-2 border-b-2 border-pink-light py-10 md:py-14 px-4" data-id="element-265">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-266">
        <div className="text-3xl mb-4" aria-hidden="true" data-id="element-267">
          ⚠️
        </div>

        <div className="font-body text-dark-gray text-base md:text-lg leading-relaxed space-y-3" data-id="element-268">
          <p data-id="element-269">Este precio forma parte de nuestra fase de lanzamiento.</p>
          <p data-id="element-270">
            Una vez que completemos esta fase, el ebook vuelve a su precio
            regular.
          </p>
          <p className="font-semibold" data-id="element-271">
            No hay un contador aquí — pero este precio no va a durar.
          </p>
        </div>
      </div>
    </section>;
}